export const GET_PROFILE__REQUEST = 'PROFILE_TYPE__GET_PROFILE__REQUEST';
export const GET_PROFILE__SUCCESS = 'PROFILE_TYPE__GET_PROFILE__SUCCESS';
export const GET_PROFILE__FAILURE = 'PROFILE_TYPE__GET_PROFILE__FAILURE';
